
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import {} from "@newview/ui";
import mainSubMenu from "./main-submenu.vue";
@Component({
  name: "mainMenuVertical",
  components: {
    mainSubMenu
  },
})
export default class mainMenuVertical extends BaseVue {
  @Prop({ default: () => "vertical" }) mode!: any; //
  @Prop({ default: () => false }) isCollapsed!: Boolean; 
  @Prop({ default: () => '' }) activeName!: any; 
  menuList: any = [];
  openMenu: any = localStorage.getItem("openMenu");
  SubmenuClasses = this.isCollapsed ? "menuCollapsed" : "";
  
  @Watch("isCollapsed")
  isCollapsedChange(newVal: Boolean) {
    this.SubmenuClasses = newVal ? "menuCollapsed" : "";
  }
  created() {
    let menuData: any = localStorage.getItem("MainMenuDatas");
    this.menuList = this.Baselinq.from(JSON.parse(menuData)).where(e=>e["moduleName"]!="BIM应用").toArray();    
    if(this.isNull(this.openMenu)||this.openMenu.length==0){
      this.openMenu=[]
      this.loadOpenMenu(this.menuList)
    }else{
      this.openMenu = this.openMenu.split(",");
    }
  }
  loadOpenMenu(menuList){
    if(menuList.length==1){
      this.openMenu.push(menuList[0].moduleName)
      if(menuList[0].children && menuList[0].children.length==1){
        this.loadOpenMenu(menuList[0].children)
      }
    }
  }
  mounted() {
    this.toggleMenu(this.openMenu, false); //隐藏收起的菜单
	}
  
  //菜单展开/收缩
  toggleMenu(event, issave = true) {
    if(this.mode=="vertical"){
      if (event.toString() != "") {
        $(".ivu-menu-submenu.menu-lev1").each(function () {
          if (
            $(this).children(".ivu-menu-submenu-title").find("span").text() ==
            event[0]
          ) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      } else {
        $(".ivu-menu-submenu").show();
      }
      if (issave) {
        localStorage.setItem("openMenu", event.toString());
        this.openMenu = event;
      }
    }    
  }
}
